<template>
  <div v-if="!!isValid" class="row" :class="customClass">
    <slot name="scheduler" />
  </div>
</template>

<script>
export default {
  varVue: 0,
  monthFrom: 0,
  dayFrom: 0,
  yearFrom: 0,
  monthTo: 0,
  dayTo: 0,
  yearTo: 0,
  monthFromDetail: 0,
  dayFromDetail: 0,
  yearFromDetail: 0,
  monthToDetail: 0,
  dayToDetail: 0,
  yearToDetail: 0,

  offsetHours: 0,
  offsetMinutes: 0,

  props: {
    schedulerType: { type: String, default: 'Default Text' },
    mondayDay: { type: String, default: '0' },
    tuesdayDay: { type: String, default: '0' },
    wednesdayDay: { type: String, default: '0' },
    thursdayDay: { type: String, default: '0' },
    fridayDay: { type: String, default: '0' },
    saturdayDay: { type: String, default: '0' },
    sundayDay: { type: String, default: '0' },
    mondayDetDay: { type: String, default: '0' },
    tuesdayDetDay: { type: String, default: '0' },
    wednesdayDetDay: { type: String, default: '0' },
    thursdayDetDay: { type: String, default: '0' },
    fridayDetDay: { type: String, default: '0' },
    saturdayDetDay: { type: String, default: '0' },
    sundayDetDay: { type: String, default: '0' },
    monday2fridayDay: { type: String, default: '' },
    saturday2sundayDay: { type: String, default: '' },
    setdateFrom: { type: String, default: '' },
    setdateTo: { type: String, default: '' },
    setdateDetFrom: { type: String, default: '' },
    setdateDetTo: { type: String, default: '' },
    mondayHours: { type: String, default: '' },
    tuesdayHours: { type: String, default: '' },
    wednesdayHours: { type: String, default: '' },
    thursdayHours: { type: String, default: '' },
    fridayHours: { type: String, default: '' },
    saturdayHours: { type: String, default: '' },
    sundayHours: { type: String, default: '' },
    monday2fridayHours: { type: String, default: '' },
    saturday2sundayHours: { type: String, default: '' },
    forDatesHours: { type: String, default: '' },
    forDatesDetHours: { type: String, default: '' },
    monthFromString: { type: String, default: '' },
    dayFromString: { type: String, default: '' },
    yearFromString: { type: String, default: '' },
    monthToString: { type: String, default: '' },
    dayToString: { type: String, default: '' },
    yearToString: { type: String, default: '' },
    monthFromDetailString: { type: String, default: '' },
    dayFromDetailString: { type: String, default: '' },
    yearFromDetailString: { type: String, default: '' },
    monthToDetailString: { type: String, default: '' },
    dayToDetailString: { type: String, default: '' },
    yearToDetailString: { type: String, default: '' },
    offsetHoursString: { type: String, default: '' },
    offsetMinutesString: { type: String, default: '' },
    customClass: { type: String, default: '' },
  },
  data () {
    return {
      isValid: false,
      isModePreview: 0
    }
  },
  computed: {

  },
  mounted () {
    // console.log("Mounted");
    // console.log("Scheduler DType: "+this.schedulerType);
    // console.log("Monday Day: "+this.mondayDay);
    // console.log("Tuesday Day: "+this.tuesdayDay);
    // console.log("Wednesday Day: "+this.wednesdayDay);
    // console.log("Thursday Day: "+this.thursdayDay);
    // console.log("Friday Day: "+this.fridayDay);
    // console.log("Saturday Day: "+this.saturdayDay);
    // console.log("Sunday Day: "+this.sundayDay);
    // console.log("Monday Det Day: "+this.mondayDetDay);
    // console.log("Tuesday Det Day: "+this.tuesdayDetDay);
    // console.log("Wednesday Det Day: "+this.wednesdayDetDay);
    // console.log("Thursday Det Day: "+this.thursdayDetDay);
    // console.log("Friday Det Day: "+this.fridayDetDay);
    // console.log("Saturday Det Day: "+this.saturdayDetDay);
    // console.log("Sunday Det Day: "+this.sundayDetDay);
    // console.log("Monday-Friday Day: "+this.monday2fridayDay);
    // console.log("Saturday-Sunday Day: "+this.saturday2sundayDay);

    //console.log("setdateFrom: "+this.setdateFrom);
    //console.log("setdateTo: "+this.setdateTo);

    // console.log("setdateDetFrom: "+this.setdateDetFrom);
    // console.log("setdateDetTo: "+this.setdateDetTo);

    // console.log("mondayHours: "+this.mondayHours);
    // console.log("tuesdayHours: "+this.tuesdayHours);
    // console.log("wednesdayHours: "+this.wednesdayHours);
    // console.log("thursdayHours: "+this.thursdayHours);
    // console.log("fridayHours: "+this.fridayHours);
    // console.log("saturdayHours: "+this.saturdayHours);
    // console.log("sundayHours: "+this.sundayHours);
    // console.log("monday2fridayHours: "+this.monday2fridayHours);
    // console.log("saturday2sundayHours: "+this.saturday2sundayHours);
    // console.log("forDatesHours: "+this.forDatesHours);
    // console.log("forDatesDetHours: "+this.forDatesDetHours);

    // console.log("monthFrom: "+this.monthFromString);
    // console.log("dayFrom: "+this.dayFromString);
    // console.log("yearFrom: "+this.yearFromString);
    // console.log("monthTo: "+this.monthToString);
    // console.log("dayTo: "+this.dayToString);
    // console.log("yearTo: "+this.yearToString);
    // console.log("monthFromDetail: "+this.monthFromDetailString);
    // console.log("dayFromDetail: "+this.dayFromDetailString);
    // console.log("yearFromDetail: "+this.yearFromDetailString);
    // console.log("monthToDetail: "+this.monthToDetailString);
    // console.log("dayToDetail: "+this.dayToDetailString);
    // console.log("yearToDetail: "+this.yearToDetailString);

    // console.log("offsetHours: "+this.offsetHoursString);
    // console.log("offsetMinutes: "+this.offsetMinutesString);

    // console.log("customClass: "+this.customClass);
    // console.log("customId: "+this.customId);

    // console.log('isPreview: '+this.isPreview);

    // console.log("After Data Basic");

    if (this.isPreview == 'true') {
      // console.log("Equals to string true");
    }

    if (this.isPreview == 'false') {
      // console.log("Equals to string false");
    }

    if (this.isPreview == true) {
      // console.log("Equals to value true");
      this.isModePreview = 1
    }

    if (this.isPreview == false) {
      // console.log("Equals to value false");
      this.isModePreview = 0
    }

    if (this.mondayHours == '') {
      this.mondayHours = '[]'
    }
    if (this.tuesdayHours == '') {
      this.tuesdayHours = '[]'
    }
    if (this.wednesdayHours == '') {
      this.wednesdayHours = '[]'
    }
    if (this.thursdayHours == '') {
      this.thursdayHours = '[]'
    }
    if (this.fridayHours == '') {
      this.fridayHours = '[]'
    }
    if (this.saturdayHours == '') {
      this.saturdayHours = '[]'
    }
    if (this.sundayHours == '') {
      this.sundayHours = '[]'
    }
    if (this.sundayHours == '') {
      this.sundayHours = '[]'
    }
    if (this.monday2fridayHours == '') {
      this.monday2fridayHours = '[]'
    }
    if (this.saturday2sundayHours == '') {
      this.saturday2sundayHours = '[]'
    }
    if (this.forDatesHours == '') {
      this.forDatesHours = '[]'
    }
    if (this.forDatesDetHours == '') {
      this.forDatesDetHours = '[]'
    }

    this.varVue = parseInt(this.monthFromString)
    // console.log("Valor Int varVue: "+this.varVue);

    this.monthFrom = parseInt(this.monthFromString)
    this.dayFrom = parseInt(this.dayFromString)
    this.yearFrom = parseInt(this.yearFromString)
    this.monthTo = parseInt(this.monthToString)
    this.dayTo = parseInt(this.dayToString)
    this.yearTo = parseInt(this.yearToString)
    this.monthFromDetail = parseInt(this.monthFromDetailString)
    this.dayFromDetail = parseInt(this.dayFromDetailString)
    this.yearFromDetail = parseInt(this.yearFromDetailString)
    this.monthToDetail = parseInt(this.monthToDetailString)
    this.dayToDetail = parseInt(this.dayToDetailString)
    this.yearToDetail = parseInt(this.yearToDetailString)

    this.offsetHours = parseInt(this.offsetHoursString)
    this.offsetMinutes = parseInt(this.offsetMinutesString)

    const mondayHoursArray = JSON.parse(this.mondayHours.replace(/&quot;/g, '"'))
    const tuesdayHoursArray = JSON.parse(this.tuesdayHours.replace(/&quot;/g, '"'))
    const wednesdayHoursArray = JSON.parse(this.wednesdayHours.replace(/&quot;/g, '"'))
    const thursdayHoursArray = JSON.parse(this.thursdayHours.replace(/&quot;/g, '"'))
    const fridayHoursArray = JSON.parse(this.fridayHours.replace(/&quot;/g, '"'))
    const saturdayHoursArray = JSON.parse(this.saturdayHours.replace(/&quot;/g, '"'))
    const sundayHoursArray = JSON.parse(this.sundayHours.replace(/&quot;/g, '"'))
    const monday2fridayHoursArray = JSON.parse(this.monday2fridayHours.replace(/&quot;/g, '"'))
    const saturday2sundayHoursArray = JSON.parse(this.saturday2sundayHours.replace(/&quot;/g, '"'))
    const forDatesHoursArray = JSON.parse(this.forDatesHours.replace(/&quot;/g, '"'))
    const forDatesDetHoursArray = JSON.parse(this.forDatesDetHours.replace(/&quot;/g, '"'))

    for (var indx = 0; indx < mondayHoursArray.length; indx++) {
      // console.log("mondayHours: "+mondayHoursArray[indx]['hourFrom']+", "+mondayHoursArray[indx]['hourTo']);
    }

    const date = new Date().getDate() // Get the day as a number (1-31)
    const day = new Date().getDay() // Get the weekday as a number (0-6)
    const fullyear = new Date().getFullYear() // Get the four digit year (yyyy)
    const hour = new Date().getHours() // Get the hour (0-23)
    const mili = new Date().getMilliseconds() // Get the milliseconds (0-999)
    const minu = new Date().getMinutes() // Get the minutes (0-59)
    const mon = new Date().getMonth() + 1 // Get the month (0-11)
    const sec = new Date().getSeconds() // Get the seconds (0-59)
    const time = new Date().getTime() // Get the time (milliseconds since January 1, 1970)

    const x = Date.UTC(fullyear, mon, day, hour, minu, sec, mili)

    // console.log("TO offsetHours: "+typeof this.offsetHours);

    const d = new Date()
    const gmtHours = -d.getTimezoneOffset() / 60

    // console.log("gmtHours: "+gmtHours);

    let fraccHour = 0.0
    if (parseInt(this.offsetMinutes) == 30) {
      fraccHour = 0.5
    } else {
      fraccHour = 0.0
    }

    // console.log("fraccHour: "+fraccHour);

    if (this.offsetHours < 0) {
      fraccHour = fraccHour * -1.0
    }

    // console.log("fraccHour: "+fraccHour);

    const offsetTime = parseInt(this.offsetHours) + fraccHour

    // console.log("offsetTime: "+offsetTime);

    const offsetTotal = gmtHours - offsetTime

    // console.log("fraccHour: "+fraccHour);

    const gmtInt = Math.trunc(offsetTotal)

    const diffHour = offsetTotal - gmtInt

    // console.log("gmtInt: "+gmtInt);

    let minString = ''

    if (diffHour >= 0.5) {
      minString = '30'
    } else {
      minString = '00'
    }

    let hoursigned = ''
    if (gmtInt >= -9 && gmtInt <= 0) {
      hoursigned = '-0' + Math.abs(gmtInt)
    } else if (gmtInt < -9) {
      hoursigned = '-' + Math.abs(gmtInt)
    } else if (gmtInt >= 0 && gmtInt <= 9) {
      hoursigned = '+0' + gmtInt
    } else if (gmtInt >= 10) {
      hoursigned = '+' + gmtInt
    }

    // console.log("hour signed: "+hoursigned);

    let strmon = ''
    if (mon < 10) {
      strmon = '0' + mon
    } else {
      strmon = '' + mon
    }

    let strday = ''
    if (date < 10) {
      strday = '0' + date
    } else {
      strday = '' + date
    }

    let strhour = ''
    if (hour < 10) {
      strhour = '0' + hour
    } else {
      strhour = '' + hour
    }

    let strmin = ''
    if (minu < 10) {
      strmin = '0' + minu
    } else {
      strmin = '' + minu
    }

    const dateString = '' + fullyear + '-' + strmon + '-' + strday + 'T' + strhour + ':' + strmin + ':00' + hoursigned + minString

    // console.log("Date UTC with Offset: "+dateString);

    const utcDate = new Date(x)
    // console.log("JS Date from UTC: "+utcDate);

    const y = new Date().getTimezoneOffset() / 60
    // console.log("JS getTimeZoneOffset: "+y);

    const dateTranslated = new Date(dateString)

    // console.log("Summer Time: "+this.daylights_savings(dateTranslated));

    const datet = dateTranslated.getUTCDate() // Get the day as a number (1-31)
    const dayt = dateTranslated.getUTCDay() // Get the weekday as a number (0-6)
    const fullyeart = dateTranslated.getUTCFullYear() // Get the four digit year (yyyy)
    const hourt = dateTranslated.getUTCHours() // Get the hour (0-23)
    const milit = dateTranslated.getUTCMilliseconds() // Get the milliseconds (0-999)
    const minut = dateTranslated.getUTCMinutes() // Get the minutes (0-59)
    const mont = dateTranslated.getUTCMonth() + 1 // Get the month (0-11)
    const sect = dateTranslated.getUTCSeconds() // Get the seconds (0-59)

    const curDayOfWeek = dayt
    const curHour = hourt
    const curMin = minut
    const curSec = sect
    const curDay = datet
    const curMonth = mont
    const curYear = fullyeart

    /*
    console.log("UTC curDayOfWeek: "+curDayOfWeek);
    console.log("UTC curHour: "+curHour);
    console.log("UTC curMin: "+curMin);
    console.log("UTC curSec: "+curSec);
    console.log("UTC curDay: "+curDay);
    console.log("UTC curMonth: "+curMonth);
    console.log("UTC curYear: "+curYear);
    */

    let toBeShown = 0
    let toShow = 0
    let active = 0
    let validation = 0
    let condValidRange = 0
    let condValidDetailRange = 0

    if (this.schedulerType == 'specific-days') {
      // console.log("spec days");
      if (curDayOfWeek == 1 && this.mondayDay == 1) {
        // console.log("Monday");
        if (mondayHoursArray.length > 0) {
          for (var indx = 0; indx < mondayHoursArray.length; indx++) {
            var setsh = mondayHoursArray[indx].hourFrom
            var seteh = mondayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              // console.log("Activating");
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          // console.log("mondayArray == 0");
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 2 && this.tuesdayDay == 1) {
        if (tuesdayHoursArray.length > 0) {
          for (var indx = 0; indx < tuesdayHoursArray.length; indx++) {
            var setsh = tuesdayHoursArray[indx].hourFrom
            var seteh = tuesdayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 3 && this.wednesdayDay == 1) {
        if (wednesdayHoursArray.length > 0) {
          for (var indx = 0; indx < wednesdayHoursArray.length; indx++) {
            var setsh = wednesdayHoursArray[indx].hourFrom
            var seteh = wednesdayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 4 && this.thursdayDay == 1) {
        if (thursdayHoursArray.length > 0) {
          for (var indx = 0; indx < thursdayHoursArray.length; indx++) {
            var setsh = thursdayHoursArray[indx].hourFrom
            var seteh = thursdayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 5 && this.fridayDay == 1) {
        if (fridayHoursArray.length > 0) {
          for (var indx = 0; indx < fridayHoursArray.length; indx++) {
            var setsh = fridayHoursArray[indx].hourFrom
            var seteh = fridayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 6 && this.saturdayDay == 1) {
        if (saturdayHoursArray.length > 0) {
          for (var indx = 0; indx < saturdayHoursArray.length; indx++) {
            var setsh = saturdayHoursArray[indx].hourFrom
            var seteh = saturdayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }

      if (curDayOfWeek == 0 && this.sundayDay == 1) {
        if (sundayHoursArray.length > 0) {
          for (var indx = 0; indx < sundayHoursArray.length; indx++) {
            var setsh = sundayHoursArray[indx].hourFrom
            var seteh = sundayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }
    } else if (this.schedulerType == 'range-days') {
      if (curDayOfWeek >= 1 && curDayOfWeek <= 5 && this.monday2fridayDay == 1) {
        //console.log("Range-Days");
        if (monday2fridayHoursArray.length > 0) {
          //console.log("With hours in array");
          for (var indx = 0; indx < monday2fridayHoursArray.length; indx++) {
            var setsh = monday2fridayHoursArray[indx].hourFrom
            var seteh = monday2fridayHoursArray[indx].hourTo
            //console.log("CH: "+curHour+", FH: "+setsh+", TH: "+seteh);
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              //console.log("Enabling flags");
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
          //console.log("Enabling flags")
        }
      }
      if ((curDayOfWeek == 6 || curDayOfWeek == 0) && this.saturday2sundayDay == 1) {
        if (saturday2sundayHoursArray.length > 0) {
          for (var indx = 0; indx < saturday2sundayHoursArray.length; indx++) {
            var setsh = saturday2sundayHoursArray[indx].hourFrom
            var seteh = saturday2sundayHoursArray[indx].hourTo
            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }
    } else if (this.schedulerType == 'range-date') {
      let firstDate = new Date(this.setdateFrom);
      let secondDate = new Date(this.setdateTo);

      // console.log("Testing Dates");

      // console.log("RD firstDate: ",firstDate);
      // console.log("RD secondDate: ",secondDate);

      firstDate.setDate(firstDate.getDate()+1);
      secondDate.setDate(secondDate.getDate()+1);
      let curDate = dateTranslated;

      // console.log("Testing Dates (1)");

      // console.log("RD firstDate+1: ",firstDate);
      // console.log("RD secondDate+1: ",secondDate);
      // console.log("RD curDate: ",curDate);

      if (firstDate <= curDate && curDate <= secondDate) {
        // console.log("RD Fecha valida");
        condValidRange = 1;
      }
      if (condValidRange == 1) {
        if (forDatesHoursArray.length > 0) {
          for (var indx = 0; indx < forDatesHoursArray.length; indx++) {
            var setsh = forDatesHoursArray[indx].hourFrom;
            var seteh = forDatesHoursArray[indx].hourTo;
            // console.log("RD setsh: ",setsh);
            // console.log("RD seteh: ",seteh);
            // console.log("RD curHour: ",curHour);

            if (curHour >= setsh && curHour <= (seteh - 1)) {
              toBeShown = 1
              active = 1
              validation = 1
            }
          }
        } else {
          toBeShown = 1
          toShow = 1
          active = 1
          validation = 1
        }
      }
    } else if (this.schedulerType == 'detailed-date') {
      let firstDate = new Date(this.setdateDetFrom);
      let secondDate = new Date(this.setdateDetTo);
      let curDate = dateTranslated;

      if (firstDate <= curDate && curDate <= secondDate) {
        //console.log("Fecha Det valida");
        condValidDetailRange = 1;
      }
      if (condValidDetailRange == 1) {
        if (curDayOfWeek == 1 && this.mondayDetDay == 1 || curDayOfWeek == 2 && this.tuesdayDetDay == 1 || curDayOfWeek == 3 && this.wednesdayDetDay == 1 ||
                            curDayOfWeek == 4 && this.thursdayDetDay == 1 || curDayOfWeek == 5 && this.fridayDetDay == 1 || curDayOfWeek == 6 && this.saturdayDetDay == 1 ||
                            curDayOfWeek == 0 && this.sundayDetDay == 1) {
          if (forDatesDetHoursArray.length > 0) {
            for (var indx = 0; indx < forDatesDetHoursArray.length; indx++) {
              var setsh = forDatesDetHoursArray[indx].hourFrom
              var seteh = forDatesDetHoursArray[indx].hourTo
              // console.log("hf: "+setsh);
              // console.log("ht: "+seteh);
              if (curHour >= setsh && curHour <= (seteh - 1)) {
                toBeShown = 1
                active = 1
                validation = 1
              }
            }
          } else {
            toBeShown = 1
            toShow = 1
            active = 1
            validation = 1
          }
        }
      }
    }

    if (validation == 1) {
      // console.log("It's Valid")
      this.isValid = true
    } else {
      // console.log("It isn't Valid")
      this.isValid = false
    }

    // console.log("Results");
    // console.log("toBeShown: "+toBeShown);
    // console.log("toShow: "+toShow);
    // console.log("active: "+active);
    // console.log("validation: "+validation);
  },

  methods:
            {
              daylights_savings (dt) {
                let dst = null
                for (let i = 0; i < 12; ++i) {
                  const d = new Date(dt.getFullYear(), i, 1)
                  const offset = dt.getTimezoneOffset()

                  if (dst === null) { dst = offset } else if (offset < dst) {
                    dst = offset
                    break
                  } else if (offset > dst) { break }
                }
                return (dt.getTimezoneOffset() == dst) | 0
              }
            }

}
</script>
